<header
  class="fixed w-full transition-colors duration-300 z-50 top-0 ios-status-bar-padding ios-fixed-position-fix "
  [ngClass]="{
    'bg-white shadow-md':
      (scrolled !== undefined ? scrolled : false) ||
      (isHomePage !== undefined ? !isHomePage : true) ||
      (lg !== undefined ? !lg : true),
    'bg-transparent':
      (scrolled !== undefined ? !scrolled : true) &&
      (isHomePage !== undefined ? isHomePage : false) &&
      (lg !== undefined ? lg : false)
  }"
>
  <div class="container mx-auto px-4 py-4 flex items-center justify-between  ">
    <!-- Hamburger Menu Button (Mobile & Tablet) -->
    <button
      class="lg:hidden p-2 rounded-md focus:outline-none align-center"
      (click)="toggleMobileMenu()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        [ngClass]="{
          'stroke-white':
            (scrolled !== undefined ? !scrolled : true) &&
            (isHomePage !== undefined ? isHomePage : false) &&
            (lg !== undefined ? lg : false),
          'stroke-current':
            (scrolled !== undefined ? scrolled : false) ||
            (isHomePage !== undefined ? !isHomePage : true) ||
            (lg !== undefined ? !lg : true)
        }"
      >
        @if (!isMobileMenuOpen) {
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 6h16M4 12h16M4 18h16"
        />
        } @if (isMobileMenuOpen) {
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
        }
      </svg>
    </button>
    <!-- Logo -->
    <div class="flex flex-row items-center justify-center flex-shrink-0">
      <a [routerLink]="['/']" class="flex items-center">
        <figure class="w-auto">
          <!-- Logo wrapper con overlay para efecto shine -->
          <div class="relative inline-block" #logoWrapper>
            <!-- Responsive image sizes -->
            <img
              #logoImage
              [src]="
                (lg !== undefined ? !lg : true) ||
                (scrolled !== undefined ? scrolled : false) ||
                (isHomePage !== undefined ? !isHomePage : true)
                  ? 'assets/logo/logo_full.png'
                  : 'assets/logo/logo_full_white.png'
              "
              alt="Logo Súbito"
              class="w-[60px] sm:w-[70px] md:w-[90px] lg:w-[120px] h-auto object-contain"
            />
            <span #logoShine class="logo-shine" aria-hidden="true"></span>
          </div>
        </figure>
      </a>
      <!-- Balance Component (Mobile & Tablet) -->
      @if (isLoggedIn) {
      <div class="lg:hidden ml-2">
        <shared-balance></shared-balance>
      </div>
      }
    </div>

    <!-- Navigation Menu (Desktop) -->
    <nav class="hidden lg:flex items-center space-x-8 h-full">
      <!-- Location Button (Desktop) -->
      @if (isLoggedIn) {
      <button
        (click)="openLocationModal()"
        class="text-sm sm:text-base md:text-lg lg:text-xl font-medium flex items-center gap-2 relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-yellow-400 after:transition-all after:duration-300 hover:after:w-full self-center"
        [ngClass]="{
          'text-white':
            (scrolled !== undefined ? !scrolled : true) &&
            (isHomePage !== undefined ? isHomePage : false) &&
            (lg !== undefined ? lg : false),
          'text-gray-800':
            (scrolled !== undefined ? scrolled : false) ||
            (isHomePage !== undefined ? !isHomePage : true) ||
            (lg !== undefined ? !lg : true)
        }"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          [ngClass]="{
            'stroke-white':
              (scrolled !== undefined ? !scrolled : true) &&
              (isHomePage !== undefined ? isHomePage : false) &&
              (lg !== undefined ? lg : false),
            'stroke-current':
              (scrolled !== undefined ? scrolled : false) ||
              (isHomePage !== undefined ? !isHomePage : true) ||
              (lg !== undefined ? !lg : true)
          }"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
        @if (!selectedAddress) {
        <span>Direcciones</span>
        } @if (selectedAddress) {
        <span
          class="truncate max-w-[150px]"
          title="{{ selectedAddress.ad_full_address }}"
          >{{ selectedAddress.ad_name }}</span
        >
        }
      </button>
      }

      <!-- Search Bar (Desktop) -->
      <div class="hidden md:block w-48 lg:w-64 self-center">
        <shared-search-bar></shared-search-bar>
      </div>

      <a
        [routerLink]="['/establishments-location']"
        class="text-sm sm:text-base md:text-lg lg:text-xl font-medium relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-yellow-400 after:transition-all after:duration-300 hover:after:w-full self-center lg:pt-2"
        [ngClass]="{
          'text-white':
            (scrolled !== undefined ? !scrolled : true) &&
            (isHomePage !== undefined ? isHomePage : false) &&
            (lg !== undefined ? lg : false),
          'text-gray-800':
            (scrolled !== undefined ? scrolled : false) ||
            (isHomePage !== undefined ? !isHomePage : true) ||
            (lg !== undefined ? !lg : true)
        }"
        >Establecimientos</a
      >
      @if (isLoggedIn) {
      <a
        [routerLink]="['/auth/orders']"
        class="text-sm sm:text-base md:text-lg lg:text-xl font-medium relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-yellow-400 after:transition-all after:duration-300 hover:after:w-full self-center lg:pt-2"
        [ngClass]="{
          'text-white':
            (scrolled !== undefined ? !scrolled : true) &&
            (isHomePage !== undefined ? isHomePage : false) &&
            (lg !== undefined ? lg : false),
          'text-gray-800':
            (scrolled !== undefined ? scrolled : false) ||
            (isHomePage !== undefined ? !isHomePage : true) ||
            (lg !== undefined ? !lg : true)
        }"
        >Órdenes</a
      >
      } @if (isLoggedIn) {
      <a
        [routerLink]="['/auth/perfil']"
        data-tour="profile-link"
        class="text-sm sm:text-base md:text-lg lg:text-xl font-medium relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-yellow-400 after:transition-all after:duration-300 hover:after:w-full self-center lg:pt-2"
        [ngClass]="{
          'text-white':
            (scrolled !== undefined ? !scrolled : true) &&
            (isHomePage !== undefined ? isHomePage : false) &&
            (lg !== undefined ? lg : false),
          'text-gray-800':
            (scrolled !== undefined ? scrolled : false) ||
            (isHomePage !== undefined ? !isHomePage : true) ||
            (lg !== undefined ? !lg : true)
        }"
        >Perfil</a
      >
      } @if(isLoggedIn){
      <shared-balance></shared-balance>
      }
    </nav>

    <!-- Right Side Buttons -->
    <div class="flex items-center space-x-4">
      <!-- Cart Button -->
      @if (isLoggedIn) {
      <button
        type="button"
        (click)="openCart()"
        class="p-1 rounded-full hover:bg-gray-100/20 focus:outline-none relative flex justify-center cursor-pointer"
        [ngClass]="{
          'bg-transparent':
            (scrolled !== undefined ? !scrolled : true) &&
            (lg !== undefined ? lg : false),
          'bg-white':
            (scrolled !== undefined ? scrolled : false) ||
            (lg !== undefined ? !lg : true)
        }"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 mt-1"
          fill="none"
          viewBox="0 0 24 24"
          [ngClass]="{
            'stroke-white':
              (scrolled !== undefined ? !scrolled : true) &&
              (isHomePage !== undefined ? isHomePage : false) &&
              (lg !== undefined ? lg : false),
            'stroke-current':
              (scrolled !== undefined ? scrolled : false) ||
              (isHomePage !== undefined ? !isHomePage : true) ||
              (lg !== undefined ? !lg : true)
          }"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </svg>
        <!-- Cart Item Counter Badge -->
        @if (cartService && (cartService.getTotalItems() | async) &&
        (cartService.getTotalItems() | async)! > 0) {
        <div
         class="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center transition-all duration-300 "
>
          {{ cartService.getTotalItems() | async }}
        </div>
        }
      </button>
      }

      <!-- Account Button -->
      <button
        class="px-2 py-1.5 sm:px-3 sm:py-2 md:px-4 md:py-2.5 lg:px-5 lg:py-3 rounded-full text-xs sm:text-sm md:text-base lg:text-lg font-medium"
        [ngClass]="{
          'bg-white text-gray-950 hover:bg-gray-200 transition-colors':
            (scrolled !== undefined ? !scrolled : true) &&
            (isHomePage !== undefined ? isHomePage : false) &&
            (lg !== undefined ? lg : false),
          'bg-yellow-400 text-white hover:bg-yellow-600 transition-colors':
            (scrolled !== undefined ? scrolled : false) ||
            (isHomePage !== undefined ? !isHomePage : true) ||
            (lg !== undefined ? !lg : true)
        }"
        (click)="login()"
      >
        @if (!isLoggedIn) {
        <span>Iniciar</span>
        } @else {
        <span class="hidden md:inline">Cerrar sesión</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 md:hidden"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
          />
        </svg>
        }
      </button>
    </div>
  </div>

  <!-- Mobile & Tablet Menu Overlay -->
  @if (isMobileMenuOpen) {
  <div class=" transition-all duration-500 ease-in-out lg:hidden fixed inset-0 bg-white z-50 pt-6 relative ">
    <nav class="flex flex-col items-center space-y-6 p-4">
      <!-- Location Button (Mobile) - Only icon for small screens -->
      @if (isLoggedIn) {
      <button
        (click)="openLocationModal()"
        class="w-full text-base sm:text-lg font-medium flex items-center justify-center gap-2 p-2 rounded-full bg-amber-400 text-white hover:bg-amber-500 transition-colors"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
        @if (!selectedAddress) {
        <span>Direcciones</span>
        } @if (selectedAddress) {
        <span
          class="truncate max-w-[150px]"
          title="{{ selectedAddress.ad_full_address }}"
          >{{ selectedAddress.ad_name }}</span
        >
        }
      </button>
      }
      <!-- Balance Component (Mobile Menu) -->
      <!-- Search Bar (Mobile) -->
      <div
        class="w-full sm:w-4/5 md:w-3/4 mx-auto px-4 flex justify-center mb-4"
      >
        <shared-search-bar></shared-search-bar>
      </div>
      <div class="flex flex-col items-center space-y-4 mt-4">
        <a
          [routerLink]="['/establishments-location']"
          class="text-base sm:text-lg md:text-xl font-medium hover:text-gray-900 hover:decoration-yellow-400 hover:underline hover:underline-offset-8 transition-all py-2"
          (click)="toggleMobileMenu()"
          >Establecimientos</a
        >
        @if (isLoggedIn) {
        <a
          [routerLink]="['/auth/orders']"
          class="text-base sm:text-lg md:text-xl font-medium hover:text-gray-900 hover:decoration-yellow-400 hover:underline hover:underline-offset-8 transition-all py-2"
          (click)="toggleMobileMenu()"
          >Órdenes</a
        >
        } @if (isLoggedIn) {
        <a
          [routerLink]="['/auth/perfil']"
          data-tour="profile-link"
          class="text-base sm:text-lg md:text-xl font-medium hover:text-gray-900 hover:decoration-yellow-400 hover:underline hover:underline-offset-8 transition-all py-2"
          (click)="toggleMobileMenu()"
          >Perfil</a
        >
        }
      </div>
    </nav>
  </div>
  }
</header>

@if (isLoggedIn) {
<shared-shop-cart></shared-shop-cart>
}

<shared-modal-view-location></shared-modal-view-location>

<shared-modal-confirm-logout></shared-modal-confirm-logout>
